import { render, staticRenderFns } from "./ModalHistorico.vue?vue&type=template&id=224474f2"
import script from "./ModalHistorico.vue?vue&type=script&lang=js"
export * from "./ModalHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports